import React from 'react';
import proptypes from 'prop-types';
import {
  Checkbox, TableCell, TableRow, TextField
} from '@one-thd/sui-atomic-components';

const { string, func, number, bool } = proptypes;

export const IntentRow = ({
  intentId, intent, quantity, isSelected, onSelect, showPriceColumn
}) => {
  const handleSelectionChange = () => {
    onSelect(intentId);
  };

  // Both fields are display-only: an intent is copied with the name and quantity it
  // carries in the source list, matching how ProductItem renders a product's quantity.
  // `readOnly` is what keeps them controlled inputs without an onChange handler.
  return (
    <TableRow key={`intent-${intentId}`}>
      <TableCell className="sui-bg-primary sui-text-left md:sui-px-4 sui-py-2">
        <Checkbox
          data-testid="mini-intent-checkbox"
          checked={isSelected}
          onChange={handleSelectionChange}
        />
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-left sui-px-1 sui-py-2">
        <TextField
          value={intent || ''}
          fullWidth
          InputProps={{
            readOnly: true,
            inputProps: {
              readOnly: true,
              'aria-label': `Item intent ${intent}`,
              'data-testid': 'mini-intent-name'
            }
          }}
        />
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2">
        <div className="sui-w-16 sui-max-w-16">
          <TextField
            value={quantity}
            InputProps={{
              readOnly: true,
              inputProps: {
                readOnly: true,
                style: { textAlign: 'center' },
                'aria-label': `Quantity for ${intent}`,
                'data-testid': 'mini-intent-quantity'
              }
            }}
          />
        </div>
      </TableCell>
      {showPriceColumn && (
        <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2" />
      )}
    </TableRow>
  );
};

IntentRow.propTypes = {
  intentId: string.isRequired,
  intent: string.isRequired,
  quantity: number.isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired,
  showPriceColumn: bool
};

IntentRow.defaultProps = {
  showPriceColumn: false
};
